import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Paper, Button, Grid, Divider, Skeleton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import DescriptionIcon from '@mui/icons-material/Description';
import TitleSection from '../utils/TittleTheme';
import SidebarNavigation from '../utils/SideBarNavigation';
import { database } from '../adm/admin/firebaseConfig';
import { ref, get } from '@firebase/database';

const LgpdInfoPage = () => {
    const [loading, setLoading] = useState(true);
    const [dpoData, setDpoData] = useState({
        nome: "",
        email: "",
        telefone: "",
        atoNomeacao: "",
        horarioAtendimento: ""
    });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const fetchDpoParams = async () => {
            try {
                // Busca dinâmica para bater com o padrão de gerenciamento de parâmetros do sistema
                const dpoRef = ref(database, 'config_parametros/lgpd');
                const snapshot = await get(dpoRef);
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    setDpoData(prev => ({ ...prev, ...data }));
                }
            } catch (error) {
                console.error("Erro ao carregar parâmetros da LGPD:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDpoParams();
    }, []);

    // Simulação da variável de controle regional do sistema
    const gurjao = true;

    return (
        <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, py: 5 }}>
            {/* Área de Conteúdo Principal */}
            <Box sx={{ flex: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>

                {/* Cabeçalho da Página */}
                <Box sx={{ width: "100%" }}>
                    <TitleSection
                        title="Política de Privacidade e Proteção de Dados (LGPD)"
                        subtitle="Transparência e segurança no tratamento dos seus dados pessoais em conformidade com a Lei nº 13.709/2018"
                    />
                </Box>

                {/* Bloco de Informações da Política */}
                <Paper elevation={3} sx={{ p: 4, mb: 3, borderRadius: 3, backgroundColor: '#FFFFFF' }}>

                    <Typography variant="body1" paragraph sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.7 }}>
                        Esta Política de Privacidade dispõe sobre o tratamento de dados pessoais realizado por este órgão da Administração Pública Municipal, visando proteger os direitos fundamentais de liberdade, privacidade e o livre desenvolvimento da pessoa natural, em estrita observância à <strong>Lei Geral de Proteção de Dados Pessoais (LGPD) — Lei nº 13.709, de 14 de agosto de 2018</strong>.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    {/* CAIXA DE DESTAQUE: CANAL DO ENCARREGADO (ITEM 15.2 PNTP) */}
                    {/* Renderiza apenas se houver pelo menos uma informação preenchida no dpoData */}
                    {Object.values(dpoData).some(val => val && val.trim() !== "") && (
                        <Box sx={{ mb: 4, p: 3, borderRadius: 2, border: '1px solid #E0E0E0', backgroundColor: '#F9F9F9' }}>
                            <Box display="flex" alignItems="center" gap={1} mb={2}>
                                <AdminPanelSettingsIcon color="primary" sx={{ fontSize: 28 }} />
                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#111' }}>
                                    Encarregado pelo Tratamento de Dados (DPO)
                                </Typography>
                            </Box>

                            <Typography variant="body2" sx={{ color: '#666', mb: 3, textAlign: 'justify' }}>
                                O Encarregado atua como canal de comunicação entre o controlador, os titulares dos dados e a ANPD.
                            </Typography>

                            {loading ? (
                                <Skeleton variant="rectangular" width="100%" height={100} />
                            ) : (
                                <Grid container spacing={2}>
                                    {dpoData.nome && dpoData.nome.trim() !== "" && (
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>Nome do Encarregado:</Typography>
                                            <Typography variant="body1" sx={{ color: '#222', mb: 1.5 }}>{dpoData.nome}</Typography>
                                        </Grid>
                                    )}
                                    {dpoData.atoNomeacao && dpoData.atoNomeacao.trim() !== "" && (
                                        <Grid item xs={12} sm={6}>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <DescriptionIcon sx={{ fontSize: 16, color: '#666' }} />
                                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>Ato de Nomeação:</Typography>
                                            </Box>
                                            <Typography variant="body1" sx={{ color: '#222', mb: 1.5 }}>{dpoData.atoNomeacao}</Typography>
                                        </Grid>
                                    )}
                                    {dpoData.email && dpoData.email.trim() !== "" && (
                                        <Grid item xs={12} sm={6}>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <EmailIcon sx={{ fontSize: 16, color: '#666' }} />
                                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>E-mail de Contato:</Typography>
                                            </Box>
                                            <Typography variant="body1" sx={{ color: '#0F71FD', mb: 1.5, fontWeight: '500' }}>{dpoData.email}</Typography>
                                        </Grid>
                                    )}
                                    {dpoData.telefone && dpoData.telefone.trim() !== "" && (
                                        <Grid item xs={12} sm={6}>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <PhoneIcon sx={{ fontSize: 16, color: '#666' }} />
                                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>Telefone / Canal:</Typography>
                                            </Box>
                                            <Typography variant="body1" sx={{ color: '#222', mb: 1.5 }}>{dpoData.telefone}</Typography>
                                        </Grid>
                                    )}
                                    {dpoData.horarioAtendimento && dpoData.horarioAtendimento.trim() !== "" && (
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>Horário de Atendimento Local:</Typography>
                                            <Typography variant="body1" sx={{ color: '#222' }}>{dpoData.horarioAtendimento}</Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                        </Box>
                    )}
                    {/* CONTEÚDO RESTRUTURADO PARA AS EXIGÊNCIAS DE FISCALIZAÇÃO */}
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#111', mt: 3 }}>1. Finalidade do Tratamento de Dados</Typography>
                    <Typography variant="body1" paragraph sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}>
                        A coleta e o processamento de dados pessoais pela instituição cumprem a finalidade estrita de executar as competências legais, prestar serviços públicos digitais e fornecer atendimento às demandas direcionadas pelos cidadãos, baseando-se no artigo 7º, inciso III da Lei nº 13.709/2018.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#111', mt: 3 }}>2. Coleta de Dados em Páginas de Atendimento e Ouvidoria</Typography>
                    <Typography variant="body1" paragraph sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}>
                        Dados pessoais como Nome, CPF, Telefone e E-mail são coletados ativamente nos módulos de <strong>E-SIC (Sistema de Informação ao Cidadão)</strong>, <strong>Carta de Serviços</strong> e <strong>Ouvidoria</strong>. Essas informações são fundamentais para a triagem, validação de identidade do solicitante, controle interno de prazos e resposta adequada das manifestações enviadas à administração municipal.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#111', mt: 3 }}>3. Uso de Cookies e Coleta Passiva</Typography>
                    <Typography variant="body1" paragraph sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}>
                        Utilizamos cookies técnicos essenciais apenas para garantir a estabilidade da navegação, otimização de velocidade e gravação de preferências de acessibilidade. Não realizamos o rastreamento ou comercialização de dados comportamentais para fins publicitários. O usuário tem total controle para desativar os cookies alterando as diretivas de privacidade do seu navegador.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#111', mt: 3 }}>4. Segurança no Armazenamento e Autenticação</Typography>
                    <Typography variant="body1" paragraph sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}>
                        Para assegurar a integridade das informações armazenadas, o portal utiliza criptografia em tráfego por meio de certificado SSL/TLS de ponta. Os dados residem em infraestrutura de nuvem segura com controle estrito de privilégios. A área restrita administrativa requer autenticação eletrônica robusta, impedindo intervenções ou vazamentos de dados por agentes não autorizados.
                    </Typography>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#111', mt: 3 }}>
                        5. Compartilhamento de Dados com Terceiros
                    </Typography>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}
                    >
                        A BIGSTAR SOFTWARES atua exclusivamente como fornecedora da plataforma de gestão administrativa, disponibilizando infraestrutura tecnológica segura e adotando medidas técnicas e organizacionais adequadas para a proteção dos dados armazenados e processados em seus sistemas.
                    </Typography>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}
                    >
                        O eventual compartilhamento de informações com terceiros poderá ocorrer exclusivamente por determinação, configuração ou utilização realizada pelo órgão, entidade ou empresa contratante, especialmente em integrações com sistemas externos, portais de transparência, plataformas de e-SIC, emissão de contracheques, sistemas governamentais, prestadores de serviços ou outras soluções tecnológicas de terceiros.
                    </Typography>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}
                    >
                        Nesses casos, a responsabilidade pelo tratamento dos dados compartilhados observará as atribuições de cada agente envolvido, nos termos da legislação aplicável, cabendo aos respectivos operadores e controladores garantir a conformidade, a segurança e a proteção das informações sob sua gestão.
                    </Typography>

                    {/* SEÇÃO DE DIREITOS DO TITULAR (ITEM 15.3 PNTP) */}
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#111', mt: 3 }}>5. Seus Direitos e Canal de Peticionamento</Typography>
                    <Typography variant="body1" paragraph sx={{ color: '#444', textAlign: 'justify', lineHeight: 1.6 }}>
                        De acordo com o Art. 18 da LGPD, o cidadão possui o direito de confirmar a existência de tratamento, acessar seus dados guardados, solicitar correções de inconsistências ou requerer a anonimização/bloqueio de dados desnecessários. O canal oficial instituído para exercer estes direitos é o próprio módulo digital do E-SIC.
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'left', mt: 2, mb: 4 }}>
                        <Button
                            variant="contained"
                            href="/e-sic"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                borderRadius: 2,
                                px: 3,
                                py: 1.2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                backgroundColor: '#0F71FD',
                                color: '#FFF',
                                '&:hover': {
                                    backgroundColor: '#0c5ecb',
                                    transform: 'scale(1.02)'
                                }
                            }}
                        >
                            <InfoOutlinedIcon sx={{ fontSize: 20 }} />
                            Acessar Canal de Direitos do Titular (E-SIC)
                        </Button>
                    </Box>



                </Paper>
            </Box>

            {/* Barra de Navegação Lateral */}
            {/* <Box sx={{ flex: { xs: 1, md: 1.5 }, minWidth: 250 }} marginTop={0}>
                <SidebarNavigation />
            </Box> */}
        </Container>
    );
};

export default LgpdInfoPage;